import { tagAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
const helpers = createMultiStyleConfigHelpers(tagAnatomy.keys);
export default helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      borderRadius: 'full'
    },
    label: {
      textTransform: 'uppercase',
      fontWeight: 600
    }
  },
  sizes: {
    sm: {
      container: {
        height: '21px',
        fontSize: '11px'
      }
    }
  },
  variants: {
    hiring: {
      container: {
        backgroundColor: '#fde6e8',
        color: 'CARNABY.regular'
      }
    },
    learning: {
      container: {
        backgroundColor: '#ebecfa',
        color: 'MACARON.dark'
      }
    },
    meeting: {
      container: {
        backgroundColor: '#e9f7f7',
        color: 'ZAMBA.extraDark'
      }
    },
    troubleshooting: {
      container: {
        backgroundColor: '#e0edf5',
        color: 'ATLANTIC.regular'
      }
    },
    jobHunting: {
      container: {
        backgroundColor: '#ffebe7',
        color: 'SOLARIS.extraDark'
      }
    }
  }
});